<template>
    <div>
        <h1>{{ datas.question }}</h1>
        <div>
            <p v-for="(option, index) in datas.options" :key="index" class="choice">
                <button @click="$store.commit('setCurrentStep', option.value); $store.state.stepsName.push(option.reponse)" :class='[index === $store.state.stepsName.length -1 ? "current" : "previous"]'>{{ option.name }}</button>
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            datas: Object
        }
    }
</script>